<!-- THIS IS THE CORRECT ONE -->

<div
    [ngClass]="{ 'layout-loading': !initialized }"
    id="wrapper"
    data-testid="t-oc-layout-div-1752672977568-2"
>
    <oc-navbar data-testid="t-oc-layout-oc-navbar-1752672977568-1"></oc-navbar>

    <div
        class="layout-wrapper layout-oc"
        data-testid="t-oc-layout-div-1752672977568-1"
    >
        <oc-sidenav data-testid="t-oc-layout-oc-sidenav-1752672977568-1"></oc-sidenav>

        <main
            id="main"
            role="main"
            class="layout-content"
            data-testid="t-oc-layout-main-1752672977568-1"
        >
            <router-outlet></router-outlet>
        </main>
    </div>

    <oc-footer data-testid="t-oc-layout-oc-footer-1752672977568-1"></oc-footer>
</div>

<div
    class="layout-overlay"
    (click)="closeSidenav()"
    data-testid="t-oc-layout-div-1752672977568-3"
></div>
